import clsx from 'clsx'
import {Field, FormikProps} from 'formik'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'


interface Props {
    touched?: boolean
    error?: string
    name: string
    label?: string
    type?: string
    placeholder?: string
    value?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    required?: boolean
    formik?: FormikProps<any>
}
export function TextInputMoneyMask({
    touched,
    error,
    name,
    label,
    type = 'text',
    placeholder,
    value,
    onChange,
    onBlur,
    required = false,
    formik,
}: Props) {
    const defaultMaskOptions = {
        prefix: 'R$',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: '',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 8, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }

    const currencyMask = createNumberMask({
        ...defaultMaskOptions
    })
    return (
        <>
            {label && (
                <label htmlFor={name} className='form-label fs-6 fw-bolder'>
                    {label}
                    {required && <span className='text-danger'>*</span>}
                </label>
            )}
            <Field name={name} id={name}>
                {({field}: any) => (
                    <MaskedInput
                        {...field}
                        mask={currencyMask}
                        id={name}
                        placeholder={placeholder}
                        type={type}
                        value={formik ? formik.values[name] : value}
                        onChange={formik ? formik.handleChange : onChange}
                        onBlur={formik ? formik.handleBlur : onBlur}
                        className={clsx(
                            'form-control form-control-solid',
                            {
                                'is-invalid':
                                    (formik?.touched[name] && formik?.errors[name]) ||
                                    (touched && error),
                            },
                            {
                                'is-valid':
                                    (formik?.touched[name] && formik?.errors[name]) ||
                                    (touched && !error),
                            }
                        )}
                    />
                )}
            </Field>
            {(formik?.touched[name] && formik?.errors[name]) || (error) ? (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                        <span role='alert' className='text-danger'>
                            {formik?.errors[name] || error}
                        </span>
                    </div>
                </div>
            ) : null }
        </>
    )
}
